<template>
  <div class="indicador-de-carga">
    <img
      src="../../public/media/logos/loading.gif"
      alt="Icono GIF"
      class="gif-icon"
    />
  </div>
</template>

<script>
export default {
  name: "Loading",
};
</script>

<style scoped>
.indicador-de-carga img {
  width: 10%;
}
.modal-overlay,
.indicador-de-carga {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 10;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
